import { render, staticRenderFns } from "./LancarFolga.vue?vue&type=template&id=0d6d1c94"
import script from "./LancarFolga.vue?vue&type=script&lang=js"
export * from "./LancarFolga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports